import { createContext } from 'react'

import { PermissionContextType } from './type'

const defaultProvider: PermissionContextType = {
  currentPermissions: null,
  registerResourcePropsWithPermission: () => null,
  updatePermission: () => null,
  resetPermission: () => null,
  error: null,
  isLoading: true,
  menuConfig: [],
}

const PermissionContext = createContext<PermissionContextType>(defaultProvider)

PermissionContext.displayName = 'PermissionContext'

export default PermissionContext
